import { render, staticRenderFns } from "./DeviceRestrictionDetails.vue?vue&type=template&id=2286809c&scoped=true&"
import script from "./DeviceRestrictionDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceRestrictionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRestrictionDetails.vue?vue&type=style&index=0&id=2286809c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286809c",
  null
  
)

export default component.exports